import style from '../../styles/components/newsletter/newsletter-page'

const List = ({ newsletterList, onCheckboxChange }) => {
  return (
    <>
      {newsletterList.map(list => (
        <div key={list.title} className='list-item'>
          <input
            type='checkbox'
            className='checkbox'
            checked={list.checked}
            onChange={() => onCheckboxChange(list.title)}
          />
          <span className='list-title'>{list.title}</span>
          <div className='description'>{list.description}</div>
        </div>
      ))}
      <style jsx global>
        {style}
      </style>
    </>
  )
}

export default List
